import { render } from "./LicensorData.vue?vue&type=template&id=06c8fef0"
import script from "./LicensorData.vue?vue&type=script&lang=js"
export * from "./LicensorData.vue?vue&type=script&lang=js"

import "./LicensorData.vue?vue&type=style&index=0&id=06c8fef0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__